import React, { ReactNode, useCallback, useState } from "react";

import { StateCallbacks } from "../state";
import { mapTextToValue } from "../state/util";
import { DataPointValue, NonGroupTaxonomyEntry } from "../types";

interface IProps {
  children: ReactNode;
  onSelectText: (text: string) => void;
}

const findBlockId = (node: Node): string | null => {
  let parent: HTMLElement | null = node.parentElement;
  while (!!parent) {
    if (parent.classList.contains("block")) {
      return parent.getAttribute("id");
    }
    parent = parent.parentElement;
  }
  return null;
};

export const TextSelection = (props: IProps) => {
  const [selecting, setSelecting] = useState(false);
  const updateSelection = () => {
    if (!selecting) {
      return;
    }
    const selection = window.getSelection();
    if (
      selection === null ||
      selection.isCollapsed ||
      selection.anchorNode === null ||
      selection.focusNode === null
    ) {
      return;
    }
    if (findBlockId(selection.anchorNode) !== findBlockId(selection.focusNode)) {
      return;
    }
    props.onSelectText(selection.toString().trim());
  };
  return (
    <div
      onMouseDown={() => {
        setSelecting(true);
      }}
      onMouseLeave={updateSelection}
      onMouseUp={() => {
        updateSelection();
        setSelecting(false);
      }}
    >
      {props.children}
    </div>
  );
};
TextSelection.displayName = "TextSelection";

export const onSelectText = (
  activeDataPoint: NonGroupTaxonomyEntry | null,
  activeValue: DataPointValue<any> | null,
  updateValue: StateCallbacks["onUpdateValue"],
) =>
  useCallback(
    (text: string) => {
      if (!activeValue || !activeDataPoint) {
        return;
      }
      try {
        const [value, valueRaw] = mapTextToValue(text, activeDataPoint);
        updateValue(activeValue.valueKey, value, valueRaw);
      } catch (err) {
        // make a best effort to map only
        console.warn("Failed to map text to value:", err);
      }
    },
    [activeDataPoint, activeValue, updateValue],
  );
